import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      financialAnalysis: {
        FINANCIAL_ANALYSIS: 'Financial Analysis',
        QUICK_ASSESSMENT: 'Quick Assessment',
        OVERALL_ASSESSMENT: 'Overall Assessment',
        INDICATOR: 'Indicator',
        DESCRIPTION: 'Description',
        STATUS: 'Status',
        CONCERNED: 'Concerned',
        GOOD: 'Good',
        NEUTRAL: 'Neutral',
        PROFITABILITY: 'Profitability',
        VIEW_BY: 'View by:',
        Trend: 'Trend',
        'Each year': 'Each year',
        Table: 'Table',
        RATIO_NAME: 'Indicator',
        UNIT: 'Unit',
        INCOME: 'Income',
        EXPENSES: 'Expenses',
        AVERAGE: ' Average',
        ROA_AND_ROE: 'ROA & ROE',
        COMPANY: 'Company',
        INDUSTRY_AVG: 'Industry Avg',
        INDUSTRY_AVERAGE: 'Industry Average',
        DUPOND: 'Dupont Analysis',
        ROE: 'Return on Equity (ROE)',
        ASSET_MANAGEMENT_EFFICIENCY: 'Asset Management Efficiency',
        EARNING_BREAKDOWN: 'Earnings Breakdown',
        BALANCE_BREAKDOWN: 'Balance Sheet Breakdown',
        ASSET_STRUCTURE: 'Assets Structure',
        LIABILITIES_STRUCTURE: 'Liabilities Structure',
        EQUITY_STRUCTURE: 'Equity Structure',
        SHORT_TERM_INVESTMENT: 'Short-term Investments',
        LONG_TERM_INVESTMENT: 'Other Long Term Investments',
        RESOURCE_STRUCTURE: 'Resources Structure',
        IN_WHICH: 'In which:',
        CASH_BREAKDOWN: 'Cash Flow Breakdown',
        OPERATING_INCOME: 'Operating Income',
        OPERATING_INCOME_BREAKDOWN: 'Operating Income Breakdown',
        GAIN_PROPRIETARY_TRADING_BREAKDOWN:
          'Gain from Proprietary Trading Breakdown',
        BUSINESS_POSITION: 'Business Position',
        FINANCIAL_ASSET: 'Financial Assets',
        EARNING_QUALITY: 'Earnings Quality',
        COST_TO_INCOME_RATIO: 'Cost to Income ratio',
        INCOME_LOANS: 'Income from loans and receivables to Loans',
        LEVERAGE: 'Leverage',
        TOTAL_LIABILITIES_TO_EQUITY: 'Total Liabilities to Total Equity',
        LOAN_TO_EQUITY: 'Loans to Total Equity',
        FUNDING_AND_LIQUIDITY: 'Funding and Liquidity',
        CURRENT_RATIO: 'Current Ratio',
        SHORT_AND_LONG_TEARM_FUNDING: 'Short and Long-term funding',
        BANK_QUICK_ASSESSMENT_NOTE:
          '<b>Note:</b> Based on the distribution of data by banks, we use the interquartile range - the common performance range of companies in the same industry to determine a neutral range. From there, we can determine whether each indicator is good, concerned or neutral.',
        COMPLIANCE_STATUS: 'Compliance Status',
        NORMAL_RANGE: 'Normal range:',
        DEPOSIT_AND_CREDIT: 'Deposit and Credit',
        AVERAGE_COST: 'Average Cost of Financing and Credit Cost',
        CIR: 'Cost to Income ratio (CIR)',
        NIM: 'Net Interest Margin (NIM)',
        CAPITAL_AND_LEVERAGE: 'Capital And Leverage',
        INSURANCE_PREMIUM_REVENUE: 'Insurance Premium Revenue',
        OPERATIONAL_EFFICIENCY: 'Operational Efficiency',
        INSURANCE_SOLVENCY: 'Insurance Solvency',
        EQUITY_TO_ASSETS: 'Total Equity to Total Assets',
        CAR: 'Capital Adequacy Ratio (CAR)',
        EQUITY_TIER1: 'Common Equity Tier-1 Capital to Total Assets',
        LIQUIDITY: 'Liquidity',
        LOANS_TO_DEPOSIT: 'Loans to Deposit (LDR)',
        LIQUID_ASSETS_TO_TOTAL_LIABILITIES:
          'Liquid Assets to Total Liabilities',
        CURRENT_DEPOSIT_TO_LOANS:
          'Current Deposit to Medium and Long-term Loans',
        AVERAGE_COST_OF_FINANCING: 'Average Cost of Financing',
        FUNDING_STRUCTURE: 'Funding',
        LOAN_BOOK_BREAKDOWN: 'Loan Book Breakdown And Coverage',
        LOAN_PORTFOLIO_BY_QUALITY: 'Loan Portfolio By Quality',
        TOP_3_SECTOR_IN_LOAN_PORTFOLIO: 'Top 3 sector in Loan Portfolio',
        LOAN_PORTFOLIO_BY_TERM: 'Loan Portfolio By Term',
        LOAN_LOSS_TO_NPL: 'Loan Loss Provision to NPLs',
        LOAN_LOSS_TO_TOTAL_LOAN: 'Loan Loss Provision to Total Loans',
        PANEL_SETTING_NOTE: 'Customize this panel here.',
        QUICK_ASSESSMENT_NOTE:
          'Quick Assessment is a tool to quickly evaluate enterprises performance. You do not have permission to edit this panel.',
        INFORMATION: 'Information',
        INFORMATION_NOTE:
          'Select at least 1 indicator to display them on this panel.',
        SOLVENCY: 'Solvency',
        CAPITAL_STRUCTURE: 'Capital Structure',
        TOTAL_EQUITY: 'Total Equity',
        TOTAL_LIABILITIES: 'Total Liabilities',
        EQUITY: 'Equity',
        TOTAL_DEBT: 'Total debt',
        EBITDA: 'EBITDA',
        COVERAGE: 'Coverage',
        DAYS_SALE: 'Days Sales Outstanding',
        DAYS_INVENTORY: 'Days Inventory Outstanding',
        DAYS_PAYABLE: 'Days Payables Outstanding',
        CASH_CONVERSION: 'Cash Conversion Cycle',
        DAYS: 'days',
        ASSET_TURNOVER_1: 'Asset',
        ASSET_TURNOVER_2: 'Turnover',
        FIXED_ASSET_TURNOVER_1: 'Fixed',
        FIXED_ASSET_TURNOVER_2: 'Asset Turnover',
        DAYS_SALE_1: 'Days Sales Outstanding',
        DAYS_SALE_2: 'Average Accounts Receivable',
        DAYS_SALE_3: 'Annual Revenue',
        DAYS_SALE_4: 'Number of Days in Period',
        DAYS_INVENTORY_1: 'Days Inventory Outstanding',
        DAYS_INVENTORY_2: 'Average Inventory',
        DAYS_INVENTORY_3: 'Cost of Goods Sold',
        DAYS_INVENTORY_4: 'Number of Days in Period',
        DAYS_PAYABLE_1: 'Days Payables Outstanding',
        DAYS_PAYABLE_2: 'Average Accounts Payable',
        DAYS_PAYABLE_3: 'Cost of Goods Sold',
        DAYS_PAYABLE_4: 'Number of Days in Period',
        CASH_CONVERSION_1: 'Cash Conversion Cycle',
        CASH_CONVERSION_2: 'Days Sales Outstanding',
        CASH_CONVERSION_3: 'Days Inventory Outstanding',
        CASH_CONVERSION_4: 'Days Payable Outstanding',
        INTEREST_COVERAGE_1: 'Interest Coverage',
        INTEREST_COVERAGE_2: 'Interest Expense',
        ASSET_COVERAGE_1: 'Asset Coverage',
        ASSET_COVERAGE_2: 'Total Assets',
        ASSET_COVERAGE_3: 'Intangible Assets',
        ASSET_COVERAGE_4: 'Current Liabilities',
        ASSET_COVERAGE_5: 'Short-term Debt',
        ASSET_COVERAGE_6: 'Total Debt',
        EBITDA_COVERAGE_1: 'EBITDA coverage',
        EBITDA_COVERAGE_2: 'Interest Expense',
        CASH_COVERAGE_1: 'Cash Interest Coverage',
        CASH_COVERAGE_2: 'Cash',
        CASH_COVERAGE_3: 'Interest Expense',
        AVERAGE_COST_1: 'Average Cost of Financing',
        AVERAGE_COST_2: 'Interest and similar expenses',
        AVERAGE_COST_3: 'Average Total debt',
        CREDIT_COST_1: 'Credit cost',
        CREDIT_COST_2: 'Provision expenses on credit loss',
        CREDIT_COST_3: 'Average Total loans',
        LOAN_YEILD_1: 'Loan yield',
        LOAN_YEILD_2: 'Interest and similar income',
        LOAN_YEILD_3: 'Average Total Loans',
        NIM_1: 'Adjusted Net Interest Margin',
        NIM_2: 'Net Interest Income',
        NIM_3: 'Average Interest-earning assets',
        NIM_4: 'Interest-earning assets',
        NIM_5: 'Balances with the SBV',
        NIM_6: 'Placements with and loans to other credit institutions',
        NIM_7: 'Trading securities',
        NIM_8: 'Loans and advances to customers',
        NIM_9: 'Available-for-sale securities',
        NIM_10: 'Held-to-maturity investment',
        NIM_11: 'Gross debts purchased',
        NIM_12: 'Special bonds issued by VAMC',
        CIR_1: 'Cost to Income ratio (CIR)',
        CIR_2: 'Total operating expenses',
        CIR_3: 'Total operating income',
        CASA_1: 'CASA',
        CASA_2: 'CASA Deposits',
        CASA_3: 'Deposits from customers',
        MARKET_SHARE_1: 'Stock and bond brokerage market share',
        MARKET_SHARE_2: 'Value of shares and bonds of Investors',
        MARKET_SHARE_3: 'Trading value in period of investors',
        OTHER_MARKET_SHARE_1: 'Other securities brokerage market share',
        OTHER_MARKET_SHARE_2: 'Value of others of Investorsy',
        OTHER_MARKET_SHARE_3: 'Trading value in period of investors',
        INCOME_RATIO_1: 'Cost to Income ratio',
        INCOME_RATIO_2: 'Cost of sales',
        INCOME_RATIO_3: 'Selling cost',
        INCOME_RATIO_4: 'General and administrative expenses',
        INCOME_RATIO_5: 'Loss from FVTPL',
        INCOME_RATIO_6: 'Loss form HTM investment',
        INCOME_RATIO_7: 'Loss from AFS assets',
        INCOME_RATIO_8: 'Loss from derivatives',
        INCOME_RATIO_9: 'Net sales',
        INCOME_RATIO_10: 'Income from FVTPL',
        INCOME_RATIO_11: 'Income from HTM investment',
        INCOME_RATIO_12: 'Income from AFS assets',
        INCOME_RATIO_13: 'Income from derivatives',
        SHORT_TERM_1: 'Short-term funding',
        SHORT_TERM_2: 'Short-term borrowings',
        SHORT_TERM_3: 'Short term financial assets borrowings',
        SHORT_TERM_4: 'Short term convertible bonds',
        SHORT_TERM_5: 'Short term bonds issued',
        SHORT_TERM_6: 'Government bonds purchased for resale',
        LONG_TERM_1: 'Long-term funding',
        LONG_TERM_2: 'Long term financial lease',
        LONG_TERM_3: 'Long term financial assets borrowings',
        LONG_TERM_4: 'Convertible bonds',
        LONG_TERM_5: 'Long term bonds',
        LONG_TERM_6: 'Preferred shares',
        LONG_LIQUID_ASSET_1: 'Illiquid assets',
        LONG_LIQUID_ASSET_2: 'Long-term assets',
        SHORT_LIQUID_ASSET_1: 'Liquid assets',
        SHORT_LIQUID_ASSET_2: 'Current assets',
        TOTAL_LIABILITIES_1: 'Adjusted Liquid Assets',
        TOTAL_LIABILITIES_2: 'Cash, gold and gemstones',
        TOTAL_LIABILITIES_3: 'Balances with the SBV',
        TOTAL_LIABILITIES_4:
          'Placements with and loans to other credit institutions',
        TOTAL_LIABILITIES_5:
          'Government bonds and Government-guaranteed bonds ( Trading securities,',
        TOTAL_LIABILITIES_6:
          'Ready for sales investment security and Held to maturity investment security)',
        AVERAGE_COST_OF_FINANCING_1: 'Average Cost of Financing',
        NON_BANK_AVERAGE_COST_OF_FINANCING_1: 'Average Cost of Financing',
        AVERAGE_COST_OF_FINANCING_2: 'Interest and similar expenses',
        AVERAGE_COST_OF_FINANCING_3: 'Average Total debt',
        AVG: '_Industry Avg.',
        SBV_1: "The SBV's permissible limits",
        SBV_2: 'minimum ',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      financialAnalysis: {
        FINANCIAL_ANALYSIS: 'Phân Tích Tài Chính',
        QUICK_ASSESSMENT: 'Đánh Giá Nhanh',
        OVERALL_ASSESSMENT: 'Đánh giá tổng quan',
        INDICATOR: 'Chỉ tiêu',
        DESCRIPTION: 'Mô tả',
        STATUS: 'Trạng thái',
        CONCERNED: 'Đáng chú ý',
        GOOD: 'Tốt',
        NEUTRAL: 'Bình thường',
        PROFITABILITY: 'Tỷ Suất Sinh Lời',
        VIEW_BY: 'Xem theo:',
        Trend: 'Tăng trưởng',
        'Each year': 'Năm',
        Table: 'Bảng',
        RATIO_NAME: 'Chỉ tiêu',
        UNIT: 'Đơn vị',
        INCOME: 'Doanh Thu',
        EXPENSES: 'Chi Phí',
        AVERAGE: ' trung bình',
        ROA_AND_ROE: 'ROA & ROE',
        COMPANY: 'Công ty',
        INDUSTRY_AVG: 'TB Ngành',
        INDUSTRY_AVERAGE: 'Trung bình ngành',
        DUPOND: 'Phân tích Dupont',
        ROE: 'ROE',
        ASSET_MANAGEMENT_EFFICIENCY: 'Hiệu Quả Quản Lý Tài Sản',
        EARNING_BREAKDOWN: 'Cơ Cấu Doanh Thu',
        BALANCE_BREAKDOWN: 'Cơ Cấu Bảng Cân Đối Kế Toán',
        ASSET_STRUCTURE: 'Cấu Trúc Tài Sản',
        LIABILITIES_STRUCTURE: 'Cấu Trúc Nợ Phải Trả',
        EQUITY_STRUCTURE: 'Cấu Trúc Nguồn Vốn',
        SHORT_TERM_INVESTMENT: 'Đầu Tư Tài Chính Ngắn Hạn',
        LONG_TERM_INVESTMENT: 'Đầu Tư Dài Hạn Khác',
        RESOURCE_STRUCTURE: 'Cấu Trúc Tổng Nguồn Vốn',
        IN_WHICH: 'Trong đó:',
        CASH_BREAKDOWN: 'Cơ Cấu Dòng Tiền',
        OPERATING_INCOME: 'Doanh Thu Hoạt Động',
        OPERATING_INCOME_BREAKDOWN: 'Cơ Cấu Doanh Thu Hoạt Động',
        GAIN_PROPRIETARY_TRADING_BREAKDOWN: 'Cơ Cấu Thu Nhập Từ Tự Doanh',
        BUSINESS_POSITION: 'Vị Thế Trên Thị Trường',
        FINANCIAL_ASSET: 'Tài Sản Tài Chính',
        EARNING_QUALITY: 'Chất Lượng Thu Nhập',
        COST_TO_INCOME_RATIO: 'Tỷ lệ chi phí trên thu nhập',
        INCOME_LOANS:
          'Lãi từ các khoản cho vay và phải thu / Các khoản cho vay',
        LEVERAGE: 'Chỉ Số Đòn Bẩy',
        TOTAL_LIABILITIES_TO_EQUITY: 'Nợ phải trả / VCSH',
        LOAN_TO_EQUITY: 'Các khoản cho vay / VCSH',
        FUNDING_AND_LIQUIDITY: 'Cơ Cấu Vốn Và Khả Năng Thanh Toán Nhanh',
        CURRENT_RATIO: 'Tỷ số thanh khoản hiện thời',
        SHORT_AND_LONG_TEARM_FUNDING: 'Cơ cấu vốn ngắn hạn và dài hạn',
        BANK_QUICK_ASSESSMENT_NOTE:
          '<b>Ghi chú về cách đánh giá:</b> Dựa trên phân bổ dữ liệu của các ngân hàng, chúng tôi sử dụng độ trải giữa (interquartile range) - khoảng phân bổ dữ liệu  phổ biến của các công ty trong cùng ngành để xác định khoảng kết quả hoạt động bình thường. Từ đó, xác định từng chỉ số đạt ngưỡng tốt, đáng chú ý hay bình thường.',
        COMPLIANCE_STATUS: 'Mức độ tuân thủ',
        NORMAL_RANGE: 'Khoảng bình thường:',
        DEPOSIT_AND_CREDIT: 'Tiền Gửi và Tín Dụng',
        AVERAGE_COST: 'Lãi Suất Đầu Vào Bình Quân và Chi Phí Tín Dụng',
        CIR: 'Tỷ lệ chi phí trên thu nhập (CIR)',
        NIM: 'Tỷ lệ thu nhập lãi thuần điều chỉnh (NIM)',
        CAPITAL_AND_LEVERAGE: 'An Toàn Vốn và Đòn Bẩy Tài Chính',
        INSURANCE_PREMIUM_REVENUE: 'Doanh Thu Phí Bảo Hiểm',
        OPERATIONAL_EFFICIENCY: 'Hiệu Quả Hoạt Động',
        INSURANCE_SOLVENCY: 'Khả Năng Thanh Toán',
        EQUITY_TO_ASSETS: 'VCSH/ Tổng tài sản',
        CAR: 'Tỷ lệ an toàn vốn (CAR)',
        EQUITY_TIER1: 'Vốn cổ phần phổ thông cấp 1/ Tổng tài sản',
        LIQUIDITY: 'Khả Năng Thanh Toán Nhanh',
        LOANS_TO_DEPOSIT: 'Dư nợ tín dụng / Vốn huy động (LDR)',
        LIQUID_ASSETS_TO_TOTAL_LIABILITIES:
          'Tài sản lưu động (điều chỉnh) / Nợ phải trả',
        CURRENT_DEPOSIT_TO_LOANS:
          'Tỷ lệ nguồn vốn ngắn hạn được sử dụng để cho vay trung hạn và dài hạn',
        AVERAGE_COST_OF_FINANCING: 'Chi phí huy động vốn bình quân',
        FUNDING_STRUCTURE: 'Cơ Cấu Vốn',
        LOAN_BOOK_BREAKDOWN: 'Cơ Cấu Dư Nợ Cho Vay và Khả Năng Thanh Toán',
        LOAN_PORTFOLIO_BY_QUALITY: 'Chất Lượng Nợ Cho Vay',
        TOP_3_SECTOR_IN_LOAN_PORTFOLIO: 'Top 3 dư nợ cho vay theo ngành',
        LOAN_PORTFOLIO_BY_TERM: 'Dư Nợ Cho Vay Theo Kỳ Hạn',
        LOAN_LOSS_TO_NPL: 'Dự Phòng Rủi Ro Tín Dụng / Nợ Nhóm 3-5 (điều chỉnh)',
        LOAN_LOSS_TO_TOTAL_LOAN:
          'Dự Phòng Rủi Ro Tín Dụng / Tổng Dư Nợ Cho Vay',
        PANEL_SETTING_NOTE: 'Tùy chỉnh nội dung trong bảng tại đây.',
        QUICK_ASSESSMENT_NOTE:
          'Đánh Giá Nhanh là công cụ dùng để nhanh chóng phân tích sơ bộ tình hình hoạt động của các doanh nghiệp. Bạn không được cấp quyền thay đổi các điều kiện của hộp tính năng này.',
        INFORMATION: 'Thông Tin',
        INFORMATION_NOTE:
          'Chọn ít nhất 1 chỉ số để hiển thị trên hộp tính năng này.',
        SOLVENCY: 'Khả Năng Thanh Toán Dài Hạn',
        CAPITAL_STRUCTURE: 'Cấu trúc nguồn vốn',
        TOTAL_EQUITY: 'Tổng VCSH',
        TOTAL_LIABILITIES: 'Tổng nợ phải trả',
        EQUITY: 'VCSH',
        TOTAL_DEBT: 'Tổng nợ vay',
        EBITDA: 'EBITDA',
        COVERAGE: 'Khả Năng Thanh Toán Lãi Vay',
        DAYS_SALE: 'Thời gian thu hồi tiền hàng tồn đọng',
        DAYS_INVENTORY: 'Số ngày lưu thông hàng tồn kho',
        DAYS_PAYABLE: 'Số ngày phải trả nhà cung cấp',
        CASH_CONVERSION: 'Vòng quay tiền mặt',
        DAYS: 'ngày',
        ASSET_TURNOVER_1: 'Số vòng quay',
        ASSET_TURNOVER_2: 'tổng tài sản',
        FIXED_ASSET_TURNOVER_1: 'Số vòng quay',
        FIXED_ASSET_TURNOVER_2: 'tài sản cố định',
        DAYS_SALE_1: 'Thời gian thu hồi tiền hàng tồn đọng',
        DAYS_SALE_2: 'Bình quân các khoản phải thu',
        DAYS_SALE_3: 'Doanh thu hằng năm',
        DAYS_SALE_4: 'Số ngày trong kỳ',
        DAYS_INVENTORY_1: 'Số ngày lưu thông hàng tồn kho',
        DAYS_INVENTORY_2: 'Bình quân hàng tồn kho',
        DAYS_INVENTORY_3: 'Giá vốn hàng bán',
        DAYS_INVENTORY_4: 'Số ngày trong kỳ',
        DAYS_PAYABLE_1: 'Số ngày phải trả nhà cung cấp',
        DAYS_PAYABLE_2: 'Bình quân các khoản phải trả',
        DAYS_PAYABLE_3: 'Giá vốn hàng bán',
        DAYS_PAYABLE_4: 'Số ngày trong kỳ',
        CASH_CONVERSION_1: 'Vòng quay tiền mặt',
        CASH_CONVERSION_2: 'Thời gian thu hồi tiền hàng tồn đọng',
        CASH_CONVERSION_3: 'Số ngày lưu thông hàng tồn kho',
        CASH_CONVERSION_4: 'Số ngày phải trả nhà cung cấp',
        INTEREST_COVERAGE_1: 'Khả năng trả lãi EBIT',
        INTEREST_COVERAGE_2: 'Chi phí lãi vay',
        ASSET_COVERAGE_1: 'Tỷ lệ bảo đảm tài sản',
        ASSET_COVERAGE_2: 'Tổng tài sản',
        ASSET_COVERAGE_3: 'Tài sản vô hình',
        ASSET_COVERAGE_4: 'Nợ ngắn hạn',
        ASSET_COVERAGE_5: 'Nợ vay ngắn hạn',
        ASSET_COVERAGE_6: 'Tổng nợ vay',
        EBITDA_COVERAGE_1: 'Khả năng trả lãi EBITDA',
        EBITDA_COVERAGE_2: 'Chi phí lãi vay',
        CASH_COVERAGE_1: 'Khả năng trả lãi tiền mặt',
        CASH_COVERAGE_2: 'Tiền',
        CASH_COVERAGE_3: 'Chi phí lãi vay',
        AVERAGE_COST_1: 'Chi phí huy động vốn bình quân',
        AVERAGE_COST_2: 'Chi phí lãi và các chi phí tương tự',
        AVERAGE_COST_3: 'Bình quân tổng nợ vay',
        CREDIT_COST_1: 'Chi phí tín dụng',
        CREDIT_COST_2: 'Chi phí dự phòng rủi ro tín dụng',
        CREDIT_COST_3: 'Bình quân tổng nợ cho vay',
        LOAN_YEILD_1: 'Lợi suất cho vay',
        LOAN_YEILD_2: 'Thu nhập lãi và các khoản thu nhập tương tự',
        LOAN_YEILD_3: 'Bình quân tổng nợ cho vay',
        NIM_1: 'Tỷ lệ thu nhập lãi thuần điều chỉnh',
        NIM_2: 'Thu nhập lãi thuần',
        NIM_3: 'Bình quân Tài sản sinh lãi',
        NIM_4: 'Tài sản sinh lãi',
        NIM_5: 'Tiền gửi tại NHNN Việt Nam',
        NIM_6: 'Tiền gửi và cho vay các TCTD khác',
        NIM_7: 'Chứng khoán đầu tư',
        NIM_8: 'Cho vay khách hàng',
        NIM_9: 'Chứng khoán đầu tư sẵn sàng để bán',
        NIM_10: 'Chứng khoán đầu tư giữ đến ngày đáo hạn',
        NIM_11: 'Mua bán nợ',
        NIM_12: 'Trái phiếu đặc biệt do VAMC phát hành',
        CIR_1: 'Tỷ lệ chi phí trên thu nhập',
        CIR_2: 'Chi phí hoạt động',
        CIR_3: 'Tổng thu nhập hoạt động',
        CASA_1: 'CASA',
        CASA_2: 'Tiền gửi không kỳ hạn',
        CASA_3: 'Tiền gửi của khách hàng',
        MARKET_SHARE_1: 'Thị phần môi giới chứng khoán',
        MARKET_SHARE_2:
          'Giá trị giao dịch cổ phiếu và trái phiếu thực hiện trong kỳ của nhà đầu tư',
        MARKET_SHARE_3: 'Giá trị giao dịch thực hiện trong ký của nhà đầu tư',
        OTHER_MARKET_SHARE_1: 'Thị phần môi giới chứng khoán khác',
        OTHER_MARKET_SHARE_2:
          'Giá trị giao dịch chứng khoán khác thực hiện trong kỳ của nhà đầu tư',
        OTHER_MARKET_SHARE_3:
          'Giá trị giao dịch thực hiện trong ký của nhà đầu tư',
        INCOME_RATIO_1: 'Tỷ lệ chi phí trên thu nhập',
        INCOME_RATIO_2: 'Chi phí hoạt động kinh doanh',
        INCOME_RATIO_3: 'Chi phí bán hàng',
        INCOME_RATIO_4: 'Chi phí quản lý công ty chứng khoán',
        INCOME_RATIO_5: 'Lỗ từ FVTPL',
        INCOME_RATIO_6: 'Lỗ các khoản đầu tư HTM',
        INCOME_RATIO_7: 'Lỗ từ tài sản tài chính sẵn sàng để bán',
        INCOME_RATIO_8: 'Lỗ từ các công cụ phái sinh phòng ngừa rủi ro',
        INCOME_RATIO_9: 'Doanh thu thuần về hoạt động kinh doanh',
        INCOME_RATIO_10: 'Lãi từ FVTPL',
        INCOME_RATIO_11: 'Lãi từ các khoản đầu tư HTM',
        INCOME_RATIO_12: 'Lãi từ các tài sản tài chính sẵn sàng để bán',
        INCOME_RATIO_13: 'Lãi từ các công cụ phát sinh phòng ngừa rủi ro',
        SHORT_TERM_1: 'Vốn ngắn hạn',
        SHORT_TERM_2: 'Vay và nợ thuê tài sản tài chính ngắn hạn',
        SHORT_TERM_3: 'Vay tài sản tài chính ngắn hạn',
        SHORT_TERM_4: 'Trái phiếu chuyển đổi ngắn hạn',
        SHORT_TERM_5: 'Trái phiếu phát hành ngắn hạn',
        SHORT_TERM_6: 'Giao dịch mua bán lại trái phiếu chính phủ',
        LONG_TERM_1: 'Vốn dài hạn',
        LONG_TERM_2: 'Vay và nợ thuê tài sản tài chính dài hạn',
        LONG_TERM_3: 'Vay tài sản tài chính dài hạn',
        LONG_TERM_4: 'Trái phiếu chuyển đổi dài hạn',
        LONG_TERM_5: 'Trái phiếu phát hành dài hạn',
        LONG_TERM_6: 'Cổ phiếu ưu đãi',
        LONG_LIQUID_ASSET_1: 'Tài sản thanh khoản thấp',
        LONG_LIQUID_ASSET_2: 'Tài sản dài hạn',
        SHORT_LIQUID_ASSET_1: 'Tài sản lưu động',
        SHORT_LIQUID_ASSET_2: 'Tài sản ngắn hạn',
        TOTAL_LIABILITIES_1: 'Tài sản lưu động (điều chỉnh)',
        TOTAL_LIABILITIES_2: 'Tiền mặt, vàng bạc, đá quý',
        TOTAL_LIABILITIES_3: 'Tiền gửi tại Ngân hàng Trung ương',
        TOTAL_LIABILITIES_4: 'Tiền gửi và cho vay các TCTD khác',
        TOTAL_LIABILITIES_5: `Trái phiếu Chính phủ và Trái phiếu do chính phủ bảo lãnh (của Chứng khoán kinh doanh,`,
        TOTAL_LIABILITIES_6:
          'Chứng khoán đầu tư sẵn sàng để bán và Chứng khoán đầu tư giữ đến ngày đáo hạn)',
        AVERAGE_COST_OF_FINANCING_1: 'Lãi suất đầu vào bình quân',
        NON_BANK_AVERAGE_COST_OF_FINANCING_1: 'Chi phí huy động vốn bình quân',
        AVERAGE_COST_OF_FINANCING_2: 'Chi phí lãi và các chi phí tương tự',
        AVERAGE_COST_OF_FINANCING_3: 'Bình quân tổng nợ vay',
        AVG: '_TB Ngành',
        SBV_1: 'Mức quy định của Ngân hàng Nhà nước',
        SBV_2: 'tối thiểu ',
      },
    },
  }),
)
